import { render, staticRenderFns } from "./dlg_health_care_provider.vue?vue&type=template&id=52702066&scoped=true&"
import script from "./dlg_health_care_provider.vue?vue&type=script&lang=js&"
export * from "./dlg_health_care_provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52702066",
  null
  
)

export default component.exports